import { FaEnvelope, FaWhatsapp } from "react-icons/fa";

function Footer() {
    return (
        <footer className="footer">
            <p>© {new Date().getFullYear()} MomenQ. All rights reserved.</p>

            <h3 className="follow-text">Contact Us</h3>

            <div className="footer-links">
                <a
                    href="mailto:momenq.qr@gmail.com"
                    aria-label="Email"
                >
                    <FaEnvelope />
                </a>

                <a
                    href="https://wa.me/62859106695506?text=Halo, Saya mau tanya tentang Virtual Photobooth MomenQ"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                >
                    <FaWhatsapp />
                </a>

                {/* <a
                    href="mailto:youremail@example.com"
                    aria-label="Tiktok"
                >
                    <FaTiktok />
                </a> */}

                {/* <a
                    href="mailto:youremail@example.com"
                    aria-label="Instagram"
                >
                    <FaInstagram />
                </a> */}


            </div>
        </footer>
    );
}

export default Footer;
